// Use pkg: prefix for node_modules imports (Sass 1.71+ with NodePackageImporter)
.genHtml {
  // This is inbound-email HTML, not the `.text-break` utility's `word-wrap`/`word-break:
  // break-word` (MessageContent.tsx's own text branch — dead for this caller, which always
  // passes `children`). `break-word` breaks visually but the spec keeps its automatic-minimum-
  // size contribution at the token's full width, so a flex ancestor (MessageContent.tsx's
  // `.flex-fill`) still refuses to shrink below an unbroken 8000px+ run (a long URL or id with
  // no space). `anywhere` is the one value that also shrinks that contribution, so a message row
  // holds its column width instead of stretching the whole thread.
  overflow-wrap: anywhere;

  @import 'pkg:bootstrap5/scss/functions';
  @import 'pkg:bootstrap5/scss/variables';
  @import 'pkg:bootstrap5/scss/variables-dark';
  @import 'pkg:bootstrap5/scss/maps';

  @import 'pkg:bootstrap5/scss/mixins';
  @import 'pkg:bootstrap5/scss/utilities';

  @import 'pkg:bootstrap5/scss/root';
  @import 'pkg:bootstrap5/scss/reboot';
  @import 'pkg:bootstrap5/scss/type';
  @import 'pkg:bootstrap5/scss/tables';
  @import 'pkg:bootstrap5/scss/images';

  //word-break: break-all;

  table {
    @extend .table;
    @extend .table-bordered;
  }

  img {
    @extend .img-fluid;
  }

  embed,
  object,
  video {
    width: 100% !important;
    height: auto !important;
    display: inline-block;
    vertical-align: baseline;
  }

  iframe {
    width: 100% !important;
    display: inline-block;
    vertical-align: baseline;
  }

  [style] {
    color: var(--bs-body-color) !important;
  }
}
